/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_TitleInputs */

const en_image_export_title = /** @type {(inputs: Image_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image Based Subtitle Export`)
};

const fr_image_export_title = /** @type {(inputs: Image_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation de sous-titres en images`)
};

const de_image_export_title = /** @type {(inputs: Image_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildbasierter Untertitelexport`)
};

const it_image_export_title = /** @type {(inputs: Image_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione di sottotitoli basati su immagini`)
};

const ru_image_export_title = /** @type {(inputs: Image_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт субтитров на основе изображений`)
};

const es_image_export_title = /** @type {(inputs: Image_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación de subtítulos basada en imágenes`)
};

const zh_cn2_image_export_title = /** @type {(inputs: Image_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于图像的字幕导出`)
};

const ja_image_export_title = /** @type {(inputs: Image_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像ベースの字幕エクスポート`)
};

const hi_image_export_title = /** @type {(inputs: Image_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छवि आधारित उपशीर्षक निर्यात`)
};

const pt_pt2_image_export_title = /** @type {(inputs: Image_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação de legendas baseadas em imagens`)
};

/**
* | output |
* | --- |
* | "Image Based Subtitle Export" |
*
* @param {Image_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_title = /** @type {((inputs?: Image_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_title(inputs)
	if (locale === "de") return de_image_export_title(inputs)
	if (locale === "it") return it_image_export_title(inputs)
	if (locale === "ru") return ru_image_export_title(inputs)
	if (locale === "es") return es_image_export_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_title(inputs)
	if (locale === "ja") return ja_image_export_title(inputs)
	if (locale === "hi") return hi_image_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_title(inputs)
	return en_image_export_title(inputs)
});